import React from 'react';
import { format } from 'date-fns';

import { firebase } from '@app/config/fire-conf';
import { Crew } from '@app/types/movie';

import { MovieDetailsStyled, DetailStyled } from './movie-details-styled';

type MovieDetailsProps = {
  title?: string;
  crew?: Array<Crew>;
  language?: string;
  releaseDate?: firebase.firestore.Timestamp;
};

const MovieDetails = ({
  title = '',
  crew,
  language,
  releaseDate,
}: MovieDetailsProps): JSX.Element => {
  const directors = crew?.filter((item) => item.department === 'director');
  const screenplay = crew?.filter((item) => item.department === 'screenplay');
  const writers = crew?.filter((item) => item.department === 'writers');

  return (
    <MovieDetailsStyled>
      <h2>{title}</h2>
      <div className="grid grid-cols-1 gap-6 mb-24">
        {directors && directors.length > 0 ? (
          <DetailStyled>
            <h4>Directors</h4>
            <ul>
              {directors?.map((directior) => (
                <li key={directior.name}>{directior.name}</li>
              ))}
            </ul>
          </DetailStyled>
        ) : null}
        {screenplay && screenplay?.length > 0 ? (
          <DetailStyled>
            <h4>Screenplay</h4>
            <ul>
              {screenplay?.map((screenplayItem) => (
                <li key={screenplayItem.name}>{screenplayItem.name}</li>
              ))}
            </ul>
          </DetailStyled>
        ) : null}
        {writers && writers.length > 0 ? (
          <DetailStyled>
            <h4>writer</h4>
            <ul>
              {writers?.map((writer) => (
                <li key={writer.name}>{writer.name}</li>
              ))}
            </ul>
          </DetailStyled>
        ) : null}

        {releaseDate && (
          <DetailStyled>
            <h4>Release date</h4>
            <ul>
              <li>{`${format(releaseDate?.toDate(), 'do LLLL yyyy')}`} </li>
            </ul>
          </DetailStyled>
        )}
        {language && (
          <DetailStyled>
            <h4>Language</h4>
            <ul>
              <li className="uppercase">{language}</li>
            </ul>
          </DetailStyled>
        )}
      </div>
    </MovieDetailsStyled>
  );
};

export default MovieDetails;
